<div class="benefits-holder {{ documentDirection }}">
    <div *ngIf="benefits && benefits.length && benefits.slice(5).length; else fewBenefits">
        <ul class="benefits-list">
            <li *ngFor="let item of benefits.slice(0,5)">
                <img *ngIf="item.icon_url" [src]="item.icon_url" alt="">
                <serviceos-ng-system-icon *ngIf="!item.icon_url" [icon]="'check'"></serviceos-ng-system-icon>
                <span>{{item.title}}</span>
            </li>
        </ul>
        <div class="benefits-expandable" *ngIf="benefits && benefits.length && benefits.slice(5).length">
            <ul class="benefits-list" *ngIf="expanded" [@expandOnEnter] [@collapseOnLeave]>
                <li *ngFor="let item of benefits.slice(5)">
                    <img *ngIf="item.icon_url" [src]="item.icon_url" alt="">
                    <serviceos-ng-system-icon *ngIf="!item.icon_url" [icon]="'check'"></serviceos-ng-system-icon>
                    <span>{{item.title}}</span>
                </li>
            </ul>
            <span class="expand-benefits" (click)="expanded = !expanded">
                {{ expanded ? texts.expanded: texts.expand}}
            </span>
        </div>
    </div>
    <ng-template #fewBenefits>
        <ul class="benefits-list">
            <li *ngFor="let item of benefits">
                <img *ngIf="item.icon_url" [src]="item.icon_url" alt="">
                <serviceos-ng-system-icon *ngIf="!item.icon_url" [icon]="'check'"></serviceos-ng-system-icon>
                <span>{{item.title}}</span>
            </li>
        </ul>
    </ng-template>
</div>
